import { useTranslation } from 'react-i18next';

import { useStores } from '../../../../stores/useStores';
import { formatValueWithK } from '../../../../utils/helpers';
import type { FreeSpinWidgetDataType, WidgetSizeType } from '../../types';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

import { FreeSpinsSmallWidget } from './FreeSpinsSmallWidget/FreeSpinsSmallWidget';
import { FreeSpinsWideWidget } from './FreeSpinsWideWidget/FreeSpinsWideWidget';
import styles from './FreeSpinsWidget.module.scss';

interface FreeSpinsWidgetProps {
  sizeType: WidgetSizeType;
  data: FreeSpinWidgetDataType;
}

export function FreeSpinsWidget(props: FreeSpinsWidgetProps) {
  const { data, sizeType } = props;
  const { event } = data;
  const { t } = useTranslation();
  const { userFreeSpinsStore } = useStores();
  const widgetImageUrl = event.gameImageUrl;
  const count = Number(event.rounds) - Number(event.progress);
  const betAmountValue = formatValueWithK(Number(event.bet), t);
  const coinType = event.coinType || 'GC';
  const onClick = () => userFreeSpinsStore.openFreeSpinDialogById(event.id, 'widget');

  return (
    <WidgetWrapper
      smallWidgetExtended
      className={styles.wrapper}
      dataBonusCode={event.bonusCode}
      dataProvider={event.provider}
      dataTestId="free-spins-widget"
      sizeType={sizeType}
      onClick={onClick}
    >
      {sizeType === 'small' ? (
        <FreeSpinsSmallWidget count={count} eventId={event.id} widgetImageUrl={widgetImageUrl} />
      ) : (
        <FreeSpinsWideWidget
          betAmountValue={betAmountValue}
          coinType={coinType}
          count={count}
          eventId={event.id}
          widgetImageUrl={widgetImageUrl}
        />
      )}
    </WidgetWrapper>
  );
}
